import React from 'react'
import { cn } from 'lib/utils'
import { Select as ShadcnSelect } from 'components/ui/select'
import { Label } from 'components/ui/label'

export default function SelectId({ name, label, value, onChange, options, className }) {
	return (
		<div className={cn('tw-form-control w-full', className)}>
			{label && (
				<Label htmlFor={name} className="mb-1.5">
					{label}
				</Label>
			)}
			<ShadcnSelect name={name} value={value} onChange={onChange}>
				<option value="" disabled></option>
				{options.map(item => (
					<option key={item.selectId} value={item.selectId}>
						{item.selectValue}
					</option>
				))}
			</ShadcnSelect>
		</div>
	)
}
